import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonBase } from '@mui/material';
import config from '../../../config';
import Logo from '../../../ui-component/Logo';
import { MENU_OPEN } from '../../../store/actions';

const LogoSection = ({ compact = false, width = 100 }) => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();

  return (
    <ButtonBase
      disableRipple
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
      component={Link}
      to={config.defaultPath}
      aria-label="LITNET – pradžia"
      sx={{
        borderRadius: '10px',
        '&.Mui-focusVisible': { boxShadow: (theme) => `0 0 0 3px ${theme.palette.primary.light}` }
      }}
    >
      <Logo width={width} compact={compact} />
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  compact: PropTypes.bool,
  width: PropTypes.number
};

export default LogoSection;